export default __webpack_public_path__ + "static/media/Rectangle.a3f65ef1.jpg";